import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SideNav = ({ activePage }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: 'PROFILE', path: '/profile' },
    { label: 'MILLION WALL', path: '/million-wall' },
    { label: 'SALES LAB', path: '/sales-lab' },
    { label: 'STUDIO LAB', path: '/studio-lab' },
    { label: 'VIABILITY LAB', path: '/viability-lab' },
    { label: 'EXIT LAB', path: '/exit-lab' },
  ];

  return (
    <div style={styles.container}>
      {/* LOGO AREA */}
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        M.O.B.
      </div>

      {/* MENU ITEMS */}
      <div style={styles.menuContainer}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path || activePage === item.path;
          return (
            <div 
              key={item.label} 
              onClick={() => navigate(item.path)}
              style={{
                ...styles.menuItem,
                background: isActive ? '#D4AF37' : 'transparent',
                color: isActive ? '#000' : '#888',
                borderLeft: isActive ? '4px solid #fff' : '4px solid transparent'
              }}
            >
              {item.label}
            </div>
          );
        })}
      </div>

      {/* THE CURVE EFFECT */}
      <div style={styles.curveEnding}></div>
    </div>
  );
};

const styles = {
  container: {
    width: '250px',
    background: '#050505',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #222',
    position: 'relative', // Context for the curve
    flexShrink: 0, // Prevent shrinking
  },
  logoArea: {
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Orbitron',
    fontSize: '1.5rem',
    color: '#D4AF37',
    borderBottom: '1px solid #111',
    cursor: 'pointer',
    letterSpacing: '4px'
  },
  menuContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: '#050505',
  },
  menuItem: {
    padding: '20px 25px',
    cursor: 'pointer',
    fontFamily: 'Orbitron',
    fontSize: '0.9rem',
    transition: 'all 0.2s',
    fontWeight: 'bold',
  },
  // This creates the visual "Curve" at the bottom of the nav list
  curveEnding: {
    height: '50px',
    background: '#050505',
    borderBottomRightRadius: '50px', // The Smooth Curve
    borderRight: '1px solid #222',
    borderBottom: '1px solid #222',
    marginRight: '-1px' // Hides the seam
  }
};

export default SideNav;
